import React, { PropTypes } from "react";
import InputField from "components/InputField/InputField.jsx";

const ForgotPasswordForm = ({ email, onFieldChange, onSubmit }) => (
  <div className="container_global_password">
    <h2 className="password_title">PASSWORD RESET</h2>
    <p className="password_description">
      Enter your email address that you used to register. We will send you an
      email with a link to reset your password
    </p>
    <div className="container_password row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          <InputField
            className="col s12"
            label={"Email"}
            onChange={onFieldChange}
            errors={[]}
            autoComplete="new-password"
            field_name={"email"}
            value={email}
          />
          <div className="submit_center col s12">
            <input
              className="container_password_button"
              type="submit"
              name=""
              value="SUBMIT"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
);

ForgotPasswordForm.propTypes = {
  email: PropTypes.string,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/components/Authorization/ForgotPassword/ForgotPasswordForm.js